import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className="text-2xl font-heading font-black text-primary-600 tracking-tight">
            黑料<span className="text-foreground-900">官网</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname === "/"
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200"
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname === "/about"
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200"
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-200 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-1">
          <Link to="/" className="px-4 py-3 text-sm font-medium rounded-lg hover:bg-background-200 transition-colors cursor-pointer">首页</Link>
          {categories.map((cat) => (
            <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 text-sm font-medium rounded-lg hover:bg-background-200 transition-colors cursor-pointer">{cat.name}</Link>
          ))}
          <Link to="/about" className="px-4 py-3 text-sm font-medium rounded-lg hover:bg-background-200 transition-colors cursor-pointer">关于我们</Link>
        </div>
      )}
    </header>
  );
}